const state = {
  beusPlanData: null,
  baPlanData: null,
  geoPlanData: null,
  beusPlanDataByGroup: [],
  baPlanDataByGroup: [],
  geoPlanDataByGroup: []
}

const getters = {
  beusPlanData: state => state.beusPlanData,
  beusPlanDataByGroup: state => state.beusPlanDataByGroup,
  baPlanData: state => state.baPlanData,
  baPlanDataByGroup: state => state.baPlanDataByGroup,
  geoPlanData: state => state.geoPlanData,
  geoPlanDataByGroup: state => state.geoPlanDataByGroup
}

const mutations = {
  setBeusPlanData (state, data) {
    state.beusPlanData = data
  },
  setBeusPlanDataByGroup (state, data) {
    state.beusPlanDataByGroup = data
  },
  setBaPlanData (state, data) {
    state.baPlanData = data
  },
  setBaPlanDataByGroup (state, data) {
    state.baPlanDataByGroup = data
  },
  setGeoPlanData (state, data) {
    state.geoPlanData = data
  },
  setGeoPlanDataByGroup (state, data) {
    state.geoPlanDataByGroup = data
  }
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
